export const $ = (value: number) => {
  return `$${formatNumber(value)}`;
};

export const formatNumber = (value: number) => {
  return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
